import React, { useState, useEffect } from "react";
import { Button } from "components";
import CookieDetailsModal from "./cookie-details";
import PolicyDetailsModal from "./privacy";
import CustomizeCookieModal from "./customize";
import useCookiesPolicy from "../../hooks/useCookiesPolicy";
import { useSelector } from "react-redux";
import cookieImg from "./cookie.png";

import "./index.scss";


const Cookie = ({ isShop, isMain, isDevelopers, isAuth, isBuilder, isDashboard }) => {

	const [showCookies, setShowCookies] = useState(false);
	const [cookieDetailsModal, showCookieDetailsModal] = useState(false);
	const [privacyModal, showPrivacyModal] = useState(false);
	const [customizeCookieModal, showCustomizeCookieModal] = useState(false);
	const [variants, setVariants] = useState(['strictly', 'experience', 'measurement', 'targeting']);
	const shop = useSelector(({ common: { generalInfo, productInfo, invoice } }) => {
		return (generalInfo || {}).name ?
			(generalInfo || {}).name :
			(productInfo || {}).name ?
				(productInfo || {}).name :
				(invoice || {}).name ?
					(invoice || {}).name : ""
	});

	const { setCookies, cookies, allowTrustPilot, allowGoogleTag } = useCookiesPolicy(isShop, shop.toLowerCase());

	useEffect(() => {
		setTimeout(() => {
			setShowCookies(true);
		}, 1500)
	}, []);

	useEffect(() => {

		if(allowGoogleTag) {

			if(isMain || isDevelopers) {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'gtm.start': new Date().getTime(),
					'event': 'gtm.js'
				});

				const script = document.createElement('script');
				const body = document.getElementsByTagName('script')[0];

				script.async = true;
				script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-58WR9QK';
				body.parentNode.insertBefore(script, body);

				script.addEventListener('load', () => {
					console.log("Google Tag 1 Ready");
				});
			}

			if(isAuth || isBuilder || isDashboard) {

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'gtm.start': new Date().getTime(),
					'event': 'gtm.js'
				});

				const script = document.createElement('script');
				const body = document.getElementsByTagName('script')[0];

				script.async = true;
				script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-MP3QWGZ';
				body.parentNode.insertBefore(script, body);

				script.addEventListener('load', () => {
					console.log("Google Tag 2 Ready");
				})

			}

		}

	}, [isAuth, isBuilder, isDashboard, isMain, isDevelopers, allowGoogleTag]);

	useEffect(() => {

		if(allowTrustPilot) {
			const script = document.createElement('script')
			const body = document.getElementsByTagName('head')[0]
			script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
			script.async = true;
			body.appendChild(script)
			script.addEventListener('load', () => console.log("TrustPilot Ready"));
		}

	}, [allowTrustPilot]);

	if(cookies !== undefined || !showCookies) {
		return null;
	}

	return <>
		<div className={`paylixecommerce-cookie-container ${isShop ? 'is-shop' : ''}`}>
			<div className="paylixecommerce-cookie">
				<div>
					<div className="paylixecommerce-cookie-header">
						<img src={cookieImg} width={20} height={20} alt=""/> Notice
					</div>

					<div className="paylixecommerce-cookie-body">
						We use our own cookies as well as third-party cookies on our websites to enhance your experience, analyze our traffic, and for security and marketing. For more info or to modify cookies, see our <span onClick={() => showCookieDetailsModal(true)} className="cursor-pointer" style={{ color: "var(--purple6)" }} >Cookie Policy</span> or go to <span onClick={() => showCustomizeCookieModal(true)} className="cursor-pointer" style={{ color: "var(--purple6)" }} >Manage Settings</span>. Select "Accept All" to allow them to be used.
					</div>
				</div>

				<div className="paylixecommerce-cookie-footer">
					<div className="d-flex">
						<Button size="large" variant="secondary" onClick={() => setCookies('strictly', isShop ? `shop-cookies-${shop.toLowerCase()}` : 'paylixecommerce-cookies')} className="mr-3">Close</Button>
						<Button size="large" variant="primary" onClick={() => setCookies(variants.toString(), isShop ? `shop-cookies-${shop.toLowerCase()}` : 'paylixecommerce-cookies')}>Accept All</Button>
					</div>
				</div>
			</div>

			<CookieDetailsModal
				isShop={isShop}
				open={cookieDetailsModal}
				close={() => showCookieDetailsModal(false)}
				showPrivacy={() => {
					showCookieDetailsModal(false);
					showPrivacyModal(true);
				}}
			/>

			<PolicyDetailsModal
				isShop={isShop}
				open={privacyModal}
				close={() => showPrivacyModal(false)}
				showCookie={() => {
					showPrivacyModal(false);
					showCookieDetailsModal(true);
				}}
			/>

			<CustomizeCookieModal
				isShop={isShop}
			  	open={customizeCookieModal}
			  	close={() => showCustomizeCookieModal(false)}
			  	showCookie={() => {
					showCustomizeCookieModal(false);
					showCookieDetailsModal(true);
			  	}}
			  	variants={variants}
			  	setVariants={setVariants}
			/>

		</div>
	</>
}

export default Cookie;
